<div class="custom-dialog">
  <div class="custom-dialog__close">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="custom-dialog__picture">
    <img
      src="/shared/svg/wallet/payment-processor-error.svg"
      height="157"
      alt="Verification attempts exceeded"
    />
  </div>

  <div class="custom-dialog__content">
    <h2 class="custom-dialog__content__title">
      Verification attempts exceeded
    </h2>
    <p class="custom-dialog__content__subtitle">
      We're sorry, but you have exceeded the maximum number of verification
      attempts. Please contact our Customer Support team for assistance.
    </p>
  </div>

  <div class="custom-dialog__actions">
    <button
      mat-flat-button
      color="primary"
      class="fz-button--medium"
      fzOpenZenDesk
    >
      Contact Customer Support
    </button>
  </div>
</div>
